export default {
  STOCK: [
    {
      icon: require('../assets/images/banklogo/DBS.png'),
      title: 'DBS Bank (Hong Kong) Limited',
      acc_num: '016-478-783313006',
      bankNameTitle: 'BankNameTitle',
      bankName: 'xzBankName',
      accountNameTitle: 'AccountNameTitle',
      accountName: 'xzAccountName',
      bankAddressTitle: 'BankAddressTitle',
      bankAddress: 'xzBankAddress',
      swiftTitle: 'SwiftTitle',
      swift: 'xzSwiftCode',
      accTitleHK: 'xzSecuritiesAccTitleHK',
      accHK: 'xzSecuritiesAccHK',
      currencyHK: 'CurHK',
      accTitleUS: 'xzSecuritiesAccTitleUS',
      accUS: 'xzSecuritiesAccUS',
      currencyUS: 'CurUS',
      accTitleCN: 'xzSecuritiesAccTitleCN',
      accCN: 'xzSecuritiesAccCN',
      currencyCN: 'CurCN'
    },
    {
      icon: require('../assets/images/banklogo/BOC.png'),
      title: 'Bank of China (Hong Kong) Limited',
      acc_num: '012-873-2-002063-5',
      bankNameTitle: 'BankNameTitle',
      bankName: 'zgBankName',
      accountNameTitle: 'AccountNameTitle',
      accountName: 'zgAccountName',
      bankAddressTitle: 'BankAddressTitle',
      bankAddress: 'zgBankAddress',
      swiftTitle: 'SwiftTitle',
      swift: 'zgSwiftCode',
      accTitleHK: 'zgSecuritiesAccTitleHK',
      accHK: 'zgSecuritiesAccHK',
      currencyHK: 'CurHK',
      accTitleUS: 'zgSecuritiesAccTitleUS',
      accUS: 'zgSecuritiesAccUS',
      currencyUS: 'CurUS',
      accTitleCN: 'zgSecuritiesAccTitleCN',
      accCN: 'zgSecuritiesAccCN',
      currencyCN: 'CurCN'
    },
    {
      icon: require('../assets/images/deposit/FPS-e.png'),
      title: 'Bank of China (Hong Kong) Limited',
      acc_num: '7853658',
      // bankNameTitle: 'BankNameTitle',
      FPSName: 'FPSName',
      // accountNameTitle: 'AccountNameTitle',
      // accountName: 'zgAccountName',
      // bankAddressTitle: 'BankAddressTitle',
      // bankAddress: 'zgBankAddress',
      // swiftTitle: 'SwiftTitle',
      // swift: 'zgSwiftCode',
      accTitleHK: 'FPSSecuritiesAccTitleHK',
      accHK: 'FPSSecuritiesAccHK',
      currencyHK: 'CurHK'
      // accTitleUS: 'zgSecuritiesAccTitleUS',
      // accUS: 'zgSecuritiesAccUS',
      // currencyUS: 'CurUS',
      // accTitleCN: 'zgSecuritiesAccTitleCN',
      // accCN: 'zgSecuritiesAccCN',
      // currencyCN: 'CurCN'
    }
  ],
  FUTURES: [
    {
      icon: require('../assets/images/banklogo/DBS.png'),
      title: 'DBS Bank (Hong Kong) Limited',
      acc_num: '016-478-783313006',
      bankNameTitle: 'BankNameTitle',
      bankName: 'xzBankName',
      accountNameTitle: 'AccountNameTitle',
      accountName: 'xzAccountName',
      bankAddressTitle: 'BankAddressTitle',
      bankAddress: 'xzBankAddress',
      swiftTitle: 'SwiftTitle',
      swift: 'xzSwiftCode',
      accTitleHK: 'xzFuturesAccTitleHK',
      accHK: 'xzFuturesAccHK',
      currencyHK: 'CurHK',
      accTitleUS: 'xzFuturesAccTitleUS',
      accUS: 'xzFuturesAccUS',
      currencyUS: 'CurUS',
      accTitleCN: 'xzFuturesAccTitleCN',
      accCN: 'xzFuturesAccCN',
      currencyCN: 'CurCN'
    },
    {
      icon: require('../assets/images/banklogo/BOC.png'),
      title: 'Bank of China (Hong Kong) Limited',
      acc_num: '012-873-2-002063-5',
      bankNameTitle: 'BankNameTitle',
      bankName: 'zgBankName',
      accountNameTitle: 'AccountNameTitle',
      accountName: 'zgAccountName',
      bankAddressTitle: 'BankAddressTitle',
      bankAddress: 'zgBankAddress',
      swiftTitle: 'SwiftTitle',
      swift: 'zgSwiftCode',
      accTitleHK: 'zgFuturesAccTitleHK',
      accHK: 'zgFuturesAccHK',
      currencyHK: 'CurHK',
      accTitleUS: 'zgFuturesAccTitleUS',
      accUS: 'zgFuturesAccUS',
      currencyUS: 'CurUS',
      accTitleCN: 'zgFuturesAccTitleCN',
      accCN: 'zgFuturesAccCN',
      currencyCN: 'CurCN'
    },
    {
      icon: require('../assets/images/deposit/FPS-e.png'),
      title: 'Bank of China (Hong Kong) Limited',
      acc_num: '7025075',
      // bankNameTitle: 'BankNameTitle',
      FPSName: 'FPSName',
      // accountNameTitle: 'AccountNameTitle',
      // accountName: 'zgAccountName',
      // bankAddressTitle: 'BankAddressTitle',
      // bankAddress: 'zgBankAddress',
      // swiftTitle: 'SwiftTitle',
      // swift: 'zgSwiftCode',
      accTitleHK: 'FPSFuturesAccTitleHK',
      accHK: 'FPSFuturesAccHK',
      currencyHK: 'CurHK'
      // accTitleUS: 'zgSecuritiesAccTitleUS',
      // accUS: 'zgSecuritiesAccUS',
      // currencyUS: 'CurUS',
      // accTitleCN: 'zgSecuritiesAccTitleCN',
      // accCN: 'zgSecuritiesAccCN',
      // currencyCN: 'CurCN'
    }
  ],
  IB: [
    {
      icon: require('../assets/images/banklogo/DBS.png'),
      title: 'DBS Bank (Hong Kong) Limited',
      acc_num: '016-478-783313006',
      bankNameTitle: 'BankNameTitle',
      bankName: 'xzBankName',
      accountNameTitle: 'AccountNameTitle',
      accountName: 'xzAccountName',
      bankAddressTitle: 'BankAddressTitle',
      bankAddress: 'xzBankAddress',
      swiftTitle: 'SwiftTitle',
      swift: 'xzSwiftCode',
      accTitleHK: 'xzSecuritiesAccTitleHK',
      accHK: 'xzSecuritiesAccHK',
      currencyHK: 'CurHK',
      accTitleUS: 'xzSecuritiesAccTitleUS',
      accUS: 'xzSecuritiesAccUS',
      currencyUS: 'CurUS',
      accTitleCN: 'xzSecuritiesAccTitleCN',
      accCN: 'xzSecuritiesAccCN',
      currencyCN: 'CurCN'
    },
    {
      icon: require('../assets/images/banklogo/BOC.png'),
      title: 'Bank of China (Hong Kong) Limited',
      acc_num: '012-873-2-002063-5',
      bankNameTitle: 'BankNameTitle',
      bankName: 'zgBankName',
      accountNameTitle: 'AccountNameTitle',
      accountName: 'zgAccountName',
      bankAddressTitle: 'BankAddressTitle',
      bankAddress: 'zgBankAddress',
      swiftTitle: 'SwiftTitle',
      swift: 'zgSwiftCode',
      accTitleHK: 'zgSecuritiesAccTitleHK',
      accHK: 'zgSecuritiesAccHK',
      currencyHK: 'CurHK',
      accTitleUS: 'zgSecuritiesAccTitleUS',
      accUS: 'zgSecuritiesAccUS',
      currencyUS: 'CurUS',
      accTitleCN: 'zgSecuritiesAccTitleCN',
      accCN: 'zgSecuritiesAccCN',
      currencyCN: 'CurCN'
    },
    {
      icon: require('../assets/images/deposit/FPS-e.png'),
      title: 'Bank of China (Hong Kong) Limited',
      acc_num: '7853658',
      // bankNameTitle: 'BankNameTitle',
      FPSName: 'FPSName',
      // accountNameTitle: 'AccountNameTitle',
      // accountName: 'zgAccountName',
      // bankAddressTitle: 'BankAddressTitle',
      // bankAddress: 'zgBankAddress',
      // swiftTitle: 'SwiftTitle',
      // swift: 'zgSwiftCode',
      accTitleHK: 'FPSSecuritiesAccTitleHK',
      accHK: 'FPSSecuritiesAccHK',
      currencyHK: 'CurHK'
      // accTitleUS: 'zgSecuritiesAccTitleUS',
      // accUS: 'zgSecuritiesAccUS',
      // currencyUS: 'CurUS',
      // accTitleCN: 'zgSecuritiesAccTitleCN',
      // accCN: 'zgSecuritiesAccCN',
      // currencyCN: 'CurCN'
    }
  ],
  FOREX: [
    // {
    //   icon: require('../assets/images/banklogo/DBS.png'),
    //   title: 'DBS Bank (Hong Kong) Limited',
    //   acc_num: '016-478-783313006',
    //   bankNameTitle: 'BankNameTitle',
    //   bankName: 'xzBankName',
    //   accountNameTitle: 'AccountNameTitle',
    //   accountName: 'xzAccountName',
    //   bankAddressTitle: 'BankAddressTitle',
    //   bankAddress: 'xzBankAddress',
    //   swiftTitle: 'SwiftTitle',
    //   swift: 'xzSwiftCode',
    //   accTitleHK: 'xzForexAccTitleHK',
    //   accHK: 'xzForexAccHK',
    //   currencyHK: 'CurHK',
    //   accTitleUS: 'xzForexAccTitleUS',
    //   accUS: 'xzForexAccUS',
    //   currencyUS: 'CurUS',
    //   accTitleCN: 'xzForexAccTitleCN',
    //   accCN: 'xzForexAccCN',
    //   currencyCN: 'CurCN'
    // },
    {
      icon: require('../assets/images/banklogo/ICBC.png'),
      title: 'Bank of China (Hong Kong) Limited',
      acc_num: '012-873-2-002063-5',
      bankNameTitle: 'BankNameTitle',
      bankName: 'gsBankName',
      accountNameTitle: 'AccountNameTitle',
      accountName: 'gsAccountName',
      bankAddressTitle: 'BankAddressTitle',
      bankAddress: 'gsBankAddress',
      swiftTitle: 'SwiftTitle',
      swift: 'gsSwiftCode',
      accTitleHK: 'gsForexAccTitleHK',
      accHK: 'gsForexAccHK',
      currencyHK: 'CurHK',
      accTitleUS: 'gsForexAccTitleUS',
      accUS: 'gsForexAccUS',
      currencyUS: 'CurUS',
      accTitleCN: 'gsForexAccTitleCN',
      accCN: 'gsForexAccCN',
      currencyCN: 'CurCN'
    },
    {
      icon: require('../assets/images/deposit/FPS-e.png'),
      title: 'Bank of China (Hong Kong) Limited',
      acc_num: '4009940',
      // bankNameTitle: 'BankNameTitle',
      FPSName: 'FPSName',
      // accountNameTitle: 'AccountNameTitle',
      // accountName: 'zgAccountName',
      // bankAddressTitle: 'BankAddressTitle',
      // bankAddress: 'zgBankAddress',
      // swiftTitle: 'SwiftTitle',
      // swift: 'zgSwiftCode',
      accTitleHK: 'FPSForexAccTitleHK',
      accHK: 'FPSForexAccHK',
      currencyHK: 'CurHK'
      // accTitleUS: 'zgSecuritiesAccTitleUS',
      // accUS: 'zgSecuritiesAccUS',
      // currencyUS: 'CurUS',
      // accTitleCN: 'zgSecuritiesAccTitleCN',
      // accCN: 'zgSecuritiesAccCN',
      // currencyCN: 'CurCN'
    }
  ],
  MF: [
    // {
    //   icon: require('../assets/images/banklogo/DBS.png'),
    //   title: 'DBS Bank (Hong Kong) Limited',
    //   acc_num: '016-478-783313006',
    //   bankNameTitle: 'BankNameTitle',
    //   bankName: 'xzBankName',
    //   accountNameTitle: 'AccountNameTitle',
    //   accountName: 'xzAccountName',
    //   bankAddressTitle: 'BankAddressTitle',
    //   bankAddress: 'xzBankAddress',
    //   swiftTitle: 'SwiftTitle',
    //   swift: 'xzSwiftCode',
    //   accTitleHK: 'xzForexAccTitleHK',
    //   accHK: 'xzForexAccHK',
    //   currencyHK: 'CurHK',
    //   accTitleUS: 'xzForexAccTitleUS',
    //   accUS: 'xzForexAccUS',
    //   currencyUS: 'CurUS',
    //   accTitleCN: 'xzForexAccTitleCN',
    //   accCN: 'xzForexAccCN',
    //   currencyCN: 'CurCN'
    // },
    {
      icon: require('../assets/images/banklogo/ICBC.png'),
      title: 'Bank of China (Hong Kong) Limited',
      acc_num: '012-873-2-002063-5',
      bankNameTitle: 'BankNameTitle',
      bankName: 'gsBankName',
      accountNameTitle: 'AccountNameTitle',
      accountName: 'gsAccountName',
      bankAddressTitle: 'BankAddressTitle',
      bankAddress: 'gsBankAddress',
      swiftTitle: 'SwiftTitle',
      swift: 'gsSwiftCode',
      accTitleHK: 'gsMFAccTitleHK',
      accHK: 'gsForexAccHK',
      currencyHK: 'CurHK',
      accTitleUS: 'gsMFAccTitleUS',
      accUS: 'gsForexAccUS',
      currencyUS: 'CurUS',
      accTitleCN: 'gsMFAccTitleCN',
      accCN: 'gsForexAccCN',
      currencyCN: 'CurCN'
    }
  ],
  PM: [
    // {
    //   icon: require('../assets/images/banklogo/DBS.png'),
    //   title: 'DBS Bank (Hong Kong) Limited',
    //   acc_num: '016-478-783313006',
    //   bankNameTitle: 'BankNameTitle',
    //   bankName: 'xzBankName',
    //   accountNameTitle: 'AccountNameTitle',
    //   accountName: 'xzAccountName',
    //   bankAddressTitle: 'BankAddressTitle',
    //   bankAddress: 'xzBankAddress',
    //   swiftTitle: 'SwiftTitle',
    //   swift: 'xzSwiftCode',
    //   accTitleHK: 'xzForexAccTitleHK',
    //   accHK: 'xzForexAccHK',
    //   currencyHK: 'CurHK',
    //   accTitleUS: 'xzForexAccTitleUS',
    //   accUS: 'xzForexAccUS',
    //   currencyUS: 'CurUS',
    //   accTitleCN: 'xzForexAccTitleCN',
    //   accCN: 'xzForexAccCN',
    //   currencyCN: 'CurCN'
    // },
    {
      icon: require('../assets/images/banklogo/ICBC.png'),
      title: 'Bank of China (Hong Kong) Limited',
      acc_num: '012-873-2-002063-5',
      bankNameTitle: 'BankNameTitle',
      bankName: 'gsBankName',
      accountNameTitle: 'AccountNameTitle',
      accountName: 'gsAccountName',
      bankAddressTitle: 'BankAddressTitle',
      bankAddress: 'gsBankAddress',
      swiftTitle: 'SwiftTitle',
      swift: 'gsSwiftCode',
      accTitleHK: 'gsPMAccTitleHK',
      accHK: 'gsForexAccHK',
      currencyHK: 'CurHK',
      accTitleUS: 'gsPMAccTitleUS',
      accUS: 'gsForexAccUS',
      currencyUS: 'CurUS',
      accTitleCN: 'gsPMAccTitleCN',
      accCN: 'gsForexAccCN',
      currencyCN: 'CurCN'
    }
  ]
}
